import useUpdateAsset from './useUpdateAsset'

import useDebounce from '~lib/hooks/useDebounce'

const useUpdateAssetName = (id: string) => {
  const [updateAsset, options] = useUpdateAsset()

  const updateLaunchModuleDetails = useDebounce(
    (name: string) => {
      updateAsset({
        id,
        name,
      })
    },
    500,
    []
  )

  return [updateLaunchModuleDetails, options] as const
}

export default useUpdateAssetName
